// extracted by mini-css-extract-plugin
export var aboveInput = "_m2-0";
export var actionButton = "_m2-5";
export var actionButtonContainer = "_m2-1";
export var actionIcon = "_m2-6";
export var aiInfoContainer = "_m2-2";
export var attachmentWrapper = "_m2-7";
export var bold = "_m2-3";
export var checkIcon = "_m2-8";
export var clickingRecipientBar = "_m2-11";
export var commentThreadSwitch = "_m2-a";
export var draftImage = "_m2-b";
export var draftImageContainer = "_m2-c";
export var draftImages = "_m2-e";
export var editButton = "_m2-g";
export var editor = "_m2-f";
export var editorContainer = "_m2-y";
export var editorErrorTooltipWrapper = "_m2-9";
export var headerDivider = "_m2-h";
export var icon = "_m2-i";
export var info = "_m2-j";
export var internal = "_m2-n";
export var internalDivider = "_m2-k";
export var internalMessage = "_m2-l";
export var messageInputCard = "_m2-m";
export var messageInputForm = "_m2-o";
export var messageInputFormInternal = "_m2-p";
export var options = "_m2-q";
export var publicMessageCustomer = "_m2-s";
export var publicMessageMerchant = "_m2-r";
export var removeImageButton = "_m2-d";
export var replyButtons = "_m2-t";
export var showSignatureButton = "_m2-u";
export var spinner = "_m2-v";
export var verticalButtonDivider = "_m2-4";
export var visibilitySelector = "_m2-w";
export var warning = "_m2-x";
export var wrappingText = "_m2-z";
export var writingInternalNoteTopBorder = "_m2-10";